module.exports = __webpack_public_path__ + "static/media/track.f20df38d.svg";